export const title = {
    'en': 'TAIEX',
    'zh-tw': '台股資訊'
};

export const realTimeStockData = {
    'en': 'Real-time query [option] stock [code] to obtain [field]',
    'zh-tw': '即時查詢[option]股票[code]取得[field]'
};

export const TSE = {
    'en': 'TSE',
    'zh-tw': '上市'
};

export const OTC = {
    'en': 'OTC',
    'zh-tw': '上櫃'
};